export default __webpack_public_path__ + "static/media/fj.5c7f8461.jpg";